import { motion } from "framer-motion";

/**
 * Empty state premium avec illustration + CTA optionnel.
 */
export default function EmptyState({
  illustration,
  title,
  description,
  cta,
  testid = "empty-state",
}) {
  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="text-center py-16 px-6 bg-white rounded-[12px]"
      style={{ border: "1px solid #E5E5E5" }}
    >
      {illustration && (
        <img
          src={illustration}
          alt=""
          className="mx-auto mb-6 max-h-44 opacity-90"
          style={{ filter: "drop-shadow(0 8px 24px rgba(247,127,0,0.08))" }}
        />
      )}
      <h3
        className="text-xl font-bold mb-2"
        style={{ fontFamily: "'Sora', sans-serif", color: "#1A1A1A" }}
        data-testid={`${testid}-title`}
      >
        {title}
      </h3>
      {description && (
        <p className="text-sm mb-6 max-w-md mx-auto" style={{ color: "#666" }}>
          {description}
        </p>
      )}
      {cta}
    </motion.div>
  );
}
